
var canBeLoaded = true, // this param allows to initiate the AJAX call only if necessary
    bottomOffset = 2000; // the distance (in px) from the page bottom when you want to load more posts
module.exports = {
  init: function($) { 
        var query = $('#date_query').data('date_query');
        if( !query ) {
          query = {
            date_query: {
              after: '',
              before: ''
            }
          };
        }
        var paged = 1;
        var loadmore = true;
        $(window).scroll( () => {
          if( $(document).scrollTop() > ( $(document).height() - bottomOffset ) && loadmore ){
            $.post( '/wp-json/api/v2/board_meetings', {
              startdate: query['date_query']['after'],
              enddate: query['date_query']['before'],
              paged: paged}, (result) => {
              if( result == '' ) {
                loadmore = false;
              } else {
                $('#board_meetings_container').append( $.parseHTML( result ) );
                paged = paged + 1;
              }
            });
        }
      });
    }
}